/**
 * なんでも売却相談（簡易版）フォーム制御
 *   - 物件の種類選択でマンション名／部屋番号の表示出し分け
 *   - ふりがな自動入力
 *   ※ 郵便番号自動入力・文字数カウント・住所プルダウンの連動は form/common.js (TOOLS.CONTACT) が担当
 */

/**
 * 初期処理
 */
$(window).on('load', function() {
  oh_click_valuation_property_type1();
});

/**
 * 物件種別選択時の制御（マンション名／部屋番号の出し分け）
 */
(function () {
  $("[id^=valuation_property_type1_]").on('click', function() {
    oh_click_valuation_property_type1();
  });
}());

var oh_click_valuation_property_type1 = function() {
  switch ($('input[name="valuation_property_type1"]:checked').val()) {
    case '3':
      // マンション
      $('#item_valuation_mansion_nm').show();
      $('#item_valuation_room_no').show();
      break;
    case '2':
    case '1':
      // 戸建・土地
      $('#item_valuation_mansion_nm').hide();
      $('#item_valuation_room_no').hide();
      break;
  }
};

/**
 * ふりがな自動入力
 */
$(function() {
  $.fn.autoKana('#customer_nm', '#customer_kn');
});
